import { render, staticRenderFns } from "./detailsCustomerSalesTable.vue?vue&type=template&id=23916631&scoped=true"
import script from "./detailsCustomerSalesTable.vue?vue&type=script&lang=js"
export * from "./detailsCustomerSalesTable.vue?vue&type=script&lang=js"
import style0 from "./detailsCustomerSalesTable.vue?vue&type=style&index=0&id=23916631&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23916631",
  null
  
)

export default component.exports